<script lang="ts">
	//UI
	import PlainTextEditor from "@hitit/hub/src/components/place/PlainTextEditor.svelte";
	//Utils
	import { t } from "@hitit/hub/src/stores";
	//Types
	//Props
	export let storeDescription = "";
	export let editmode = false;
	//Constants
	const lengthLimit = 2000;
	const lineLimit = 100;
	//Variables
	let editorFocus = false;
	//Functions
	function textEditorHandler(e: { detail: { html: string } }) {
		storeDescription = e.detail.html;
	}
	const textEditorFocusBlurHandler = (bool: boolean) => {
		return () => (editorFocus = bool);
	};
	//Do
</script>

<div class="container" id="store-description" class:editmode={editmode}>
	<div class="name">{$t("hub.store.storeinfo.store_desc")}</div>
	{#if editmode}
		<div id="store-description-editor-wrapper" class:editorFocus={editorFocus}>
			<PlainTextEditor
				on:UPDATE_TEXT={textEditorHandler}
				value={storeDescription}
				lengthLimit={lengthLimit}
				lineLimit={lineLimit}
				focusEvent={textEditorFocusBlurHandler(true)}
				blurEvent={textEditorFocusBlurHandler(false)}
			/>
		</div>
	{:else}
		<div class="store-desc">
			{@html storeDescription || ""}
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../../../variables.scss";
	#store-description {
		display: flex;
		flex-direction: column;
		width: 100%;
		color: #46474b;
		gap: 10px;
		.name {
			@include appleAdjustTextForSize(14, true);
			color: #6d6f76;
		}
		.store-desc {
			@include appleAdjustTextForSize(14, true);
			color: #46474b;
			font-weight: 500;
		}

		#store-description-editor-wrapper {
			padding: 10px;
			background-color: #f0f0f4;
			min-height: 150px;
			border-radius: 5px;
			transition: box-shadow 0.1s;

			&:hover {
				cursor: text;
			}

			:global(.plainTextEditor .ql-editor) {
				outline: 0px solid transparent;
				min-height: 150px;
				overflow: auto;
				line-height: 1.375rem;
			}

			:global(.plainTextEditor .ql-editor:focus) {
				outline: 0px solid transparent;
			}

			&.editorFocus {
				box-shadow: 0 0 0 2pt var(--signature-blue);
			}
		}
	}
	@include DesktopSize {
		#store-description {
			.name {
				@include appleAdjustTextForSize(16, false);
			}
			.store-desc {
				@include appleAdjustTextForSize(16, false);
			}
			#store-description-editor-wrapper {
				font-size: 1.25rem;
				font-weight: 500;
			}
			&.editmode {
				#store-description-editor-wrapper {
					font-weight: 200;
					:global(.plainTextEditor .ql-editor) {
						line-height: 1.875rem;
					}
				}
			}
		}
	}
</style>
